import { render, staticRenderFns } from "./ItemDetailOpg.vue?vue&type=template&id=54818b90&scoped=true"
import script from "./ItemDetailOpg.vue?vue&type=script&lang=js"
export * from "./ItemDetailOpg.vue?vue&type=script&lang=js"
import style0 from "./ItemDetailOpg.vue?vue&type=style&index=0&id=54818b90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54818b90",
  null
  
)

export default component.exports